export default __webpack_public_path__ + "static/media/votes.b13ec548.svg";